export const recentPurchases = [
  { name: 'Valentina G.', city: 'Córdoba', country: 'Argentina', time: '2 minutes ago' },
  { name: 'Daniel H.', city: 'Toronto', country: 'Canada', time: '4 minutes ago' },
  { name: 'Martín L.', city: 'Rosario', country: 'Argentina', time: '6 minutes ago' },
  { name: 'Laura M.', city: 'Madrid', country: 'Spain', time: '9 minutes ago' },
  { name: 'Camila R.', city: 'Mendoza', country: 'Argentina', time: '12 minutes ago' },
  { name: 'Sophie W.', city: 'London', country: 'United Kingdom', time: '15 minutes ago' },
  { name: 'Sebastián P.', city: 'Mar del Plata', country: 'Argentina', time: '18 minutes ago' },
  { name: 'Andrés C.', city: 'Bogotá', country: 'Colombia', time: '22 minutes ago' },
  { name: 'Lucía F.', city: 'Salta', country: 'Argentina', time: '26 minutes ago' },
  { name: 'Rafael S.', city: 'São Paulo', country: 'Brazil', time: '31 minutes ago' },
]
